// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ivu-drawer-content{background-color:#1a1a1a!important}", ""]);
// Exports
module.exports = exports;
